// import React from "react";
// import { motion } from "framer-motion";

// const AboutUs = () => {
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-900 to-black text-white py-16 md:py-24">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Header Section */}
//         <div className="text-center mb-16">
//           <h1 className="text-4xl md:text-5xl font-bold mb-6">
//             About <span className="text-green-400">Quadrangle Solutions</span>
//           </h1>
//           <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto">
//             Pioneering software innovation in the shipping and logistics
//             industry for over 15 years
//           </p>
//         </div>

//         {/* Main Content */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
//           <div>
//             <h2 className="text-3xl font-bold mb-6 text-green-400">
//               Our Story
//             </h2>
//             <p className="text-gray-300 text-lg mb-6 leading-relaxed">
//               Founded in 2008, Quadrangle Solutions has been at the forefront of
//               digital transformation in the shipping and logistics sector. What
//               started as a small team of passionate developers has grown into a
//               trusted partner for organizations worldwide.
//             </p>
//             <p className="text-gray-300 text-lg mb-6 leading-relaxed">
//               Our journey began when we recognized the critical need for
//               specialized software Solutionss in maritime operations. Today, we
//               serve clients across the globe, from bustling port authorities to
//               international logistics corporations.
//             </p>
//             <div className="bg-gradient-to-r from-green-900/30 to-gray-900/50 p-6 rounded-xl border border-green-700/30">
//               <p className="text-green-400 text-lg italic">
//                 "Our mission is to empower the shipping and logistics industry
//                 with cutting-edge technology that drives efficiency, reduces
//                 costs, and enables sustainable growth."
//               </p>
//             </div>
//           </div>

//           {/* Company Image with 3D + Shadow Effect */}
//           <motion.div
//             className="relative group"
//             initial={{ opacity: 0, y: 50 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8, ease: "easeOut" }}
//             whileHover={{ scale: 1.05, rotateY: 5, rotateX: 5 }}
//           >
//             {/* Glowing background shadow layer */}
//             <div className="absolute inset-0 rounded-2xl bg-green-500/20 blur-2xl group-hover:blur-3xl transition-all duration-500"></div>

//             {/* Main Image */}
//             <img
//               src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
//               alt="Our Company Team"
//               className="relative rounded-2xl shadow-2xl border border-green-700/30 transform group-hover:rotate-1 group-hover:scale-105 transition-all duration-500"
//             />
//           </motion.div>
//         </div>

//         {/* Values Section */}
//         <div className="mb-20">
//           <h2 className="text-3xl font-bold text-center mb-16 text-green-400">
//             Our Values
//           </h2>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             <motion.div
//               className="bg-gradient-to-b from-gray-800 to-gray-900 p-8 rounded-xl border border-gray-700 group text-center"
//               whileHover={{ y: -10, scale: 1.03, borderColor: "#22c55e" }}
//               transition={{ duration: 0.4 }}
//             >
//               <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-green-900/30 text-2xl text-green-400 mb-6">
//                 💡
//               </div>
//               <h3 className="text-xl font-bold text-white mb-4">Innovation</h3>
//               <p className="text-gray-400">
//                 We constantly push boundaries to develop cutting-edge Solutionss
//                 that transform the shipping and logistics landscape.
//               </p>
//             </motion.div>

//             <motion.div
//               className="bg-gradient-to-b from-gray-800 to-gray-900 p-8 rounded-xl border border-gray-700 group text-center"
//               whileHover={{ y: -10, scale: 1.03, borderColor: "#22c55e" }}
//               transition={{ duration: 0.4 }}
//             >
//               <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-green-900/30 text-2xl text-green-400 mb-6">
//                 🤝
//               </div>
//               <h3 className="text-xl font-bold text-white mb-4">Partnership</h3>
//               <p className="text-gray-400">
//                 We build long-term relationships with our clients, working
//                 collaboratively to achieve their business objectives.
//               </p>
//             </motion.div>

//             <motion.div
//               className="bg-gradient-to-b from-gray-800 to-gray-900 p-8 rounded-xl border border-gray-700 group text-center"
//               whileHover={{ y: -10, scale: 1.03, borderColor: "#22c55e" }}
//               transition={{ duration: 0.4 }}
//             >
//               <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-green-900/30 text-2xl text-green-400 mb-6">
//                 ⚡
//               </div>
//               <h3 className="text-xl font-bold text-white mb-4">Excellence</h3>
//               <p className="text-gray-400">
//                 We are committed to delivering exceptional quality in every
//                 Solutions we create and every interaction we have.
//               </p>
//             </motion.div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AboutUs;

// import React from "react";
// import { motion } from "framer-motion";

// const AboutUs = () => {
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-white via-blue-50 to-emerald-50 text-gray-800 py-16 md:py-24">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Header Section */}
//         <div className="text-center mb-16">
//           <h1 className="text-4xl md:text-5xl font-bold mb-6">
//             About <span className="text-emerald-600">Quadrangle Solutions</span>
//           </h1>
//           <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto">
//             Pioneering software innovation in the shipping and logistics
//             industry for over 15 years
//           </p>
//         </div>

//         {/* Main Content */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
//           <div>
//             <h2 className="text-3xl font-bold mb-6 text-emerald-600">
//               Our Story
//             </h2>
//             <p className="text-gray-700 text-lg mb-6 leading-relaxed">
//               Founded in 2008, Quadrangle Solutions has been at the forefront of
//               digital transformation in the shipping and logistics sector. What
//               started as a small team of passionate developers has grown into a
//               trusted partner for organizations worldwide.
//             </p>
//             <p className="text-gray-700 text-lg mb-6 leading-relaxed">
//               Our journey began when we recognized the critical need for
//               specialized software Solutionss in maritime operations. Today, we
//               serve clients across the globe, from bustling port authorities to
//               international logistics corporations.
//             </p>
//             <div className="bg-gradient-to-r from-emerald-100 to-blue-100 p-6 rounded-xl border border-emerald-300 shadow-sm">
//               <p className="text-emerald-700 text-lg italic">
//                 "Our mission is to empower the shipping and logistics industry
//                 with cutting-edge technology that drives efficiency, reduces
//                 costs, and enables sustainable growth."
//               </p>
//             </div>
//           </div>

//           {/* Company Image with 3D + Shadow Effect */}
//           <motion.div
//             className="relative group"
//             initial={{ opacity: 0, y: 50 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8, ease: "easeOut" }}
//             whileHover={{ scale: 1.05, rotateY: 5, rotateX: 5 }}
//           >
//             {/* Subtle background shadow layer */}
//             <div className="absolute inset-0 rounded-2xl bg-emerald-200/40 blur-xl group-hover:blur-2xl transition-all duration-500"></div>

//             {/* Main Image */}
//             <img
//               src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
//               alt="Our Company Team"
//               className="relative rounded-2xl shadow-lg border border-emerald-300 transform group-hover:rotate-1 group-hover:scale-105 transition-all duration-500"
//             />
//           </motion.div>
//         </div>

//         {/* Values Section */}
//         <div className="mb-20">
//           <h2 className="text-3xl font-bold text-center mb-16 text-emerald-600">
//             Our Values
//           </h2>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             <motion.div
//               className="bg-gradient-to-b from-white to-blue-50 p-8 rounded-xl border border-gray-200 group text-center shadow-sm hover:shadow-md transition-shadow"
//               whileHover={{ y: -10, scale: 1.03, borderColor: "#059669" }}
//               transition={{ duration: 0.4 }}
//             >
//               <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-emerald-100 text-2xl text-emerald-600 mb-6">
//                 💡
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-4">
//                 Innovation
//               </h3>
//               <p className="text-gray-600">
//                 We constantly push boundaries to develop cutting-edge Solutionss
//                 that transform the shipping and logistics landscape.
//               </p>
//             </motion.div>

//             <motion.div
//               className="bg-gradient-to-b from-white to-blue-50 p-8 rounded-xl border border-gray-200 group text-center shadow-sm hover:shadow-md transition-shadow"
//               whileHover={{ y: -10, scale: 1.03, borderColor: "#059669" }}
//               transition={{ duration: 0.4 }}
//             >
//               <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-emerald-100 text-2xl text-emerald-600 mb-6">
//                 🤝
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-4">
//                 Partnership
//               </h3>
//               <p className="text-gray-600">
//                 We build long-term relationships with our clients, working
//                 collaboratively to achieve their business objectives.
//               </p>
//             </motion.div>

//             <motion.div
//               className="bg-gradient-to-b from-white to-blue-50 p-8 rounded-xl border border-gray-200 group text-center shadow-sm hover:shadow-md transition-shadow"
//               whileHover={{ y: -10, scale: 1.03, borderColor: "#059669" }}
//               transition={{ duration: 0.4 }}
//             >
//               <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-emerald-100 text-2xl text-emerald-600 mb-6">
//                 ⚡
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-4">
//                 Excellence
//               </h3>
//               <p className="text-gray-600">
//                 We are committed to delivering exceptional quality in every
//                 Solutions we create and every interaction we have.
//               </p>
//             </motion.div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AboutUs;

// import React from "react";
// import { motion } from "framer-motion";

// const AboutUs = () => {
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-white via-blue-50 to-emerald-50 text-gray-800 py-16 md:py-24">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Header Section */}
//         <div className="text-center mb-16">
//           <h1 className="text-4xl md:text-5xl font-bold mb-6">
//             About <span className="text-emerald-600">Quadrangle Solutions</span>
//           </h1>
//           <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto">
//             Pioneering software innovation in the shipping and logistics
//             industry for over 15 years
//           </p>
//         </div>
//         {/* Main Content */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
//           <div>
//             <h2 className="text-3xl font-bold mb-6 text-emerald-600">
//               Our Story
//             </h2>
//             <p className="text-gray-700 text-lg mb-6 leading-relaxed">
//               Our story began in 2010, when Quadrangle Solutions was founded in
//               India with a simple yet ambitious vision — to make technology
//               solve real industry challenges. With modest beginnings, we
//               identified a critical gap in the shipping and logistics sector:
//               the absence of specialized software that could truly simplify
//               complex operations. This realization sparked our journey,
//               inspiring us to build AI-driven solutions that not only addressed
//               these challenges but also empowered businesses to move faster,
//               work smarter, and operate more efficiently.
//             </p>
//             <div className="bg-gradient-to-r from-emerald-100 to-blue-100 p-6 rounded-xl border border-emerald-300 shadow-sm">
//               <p className="text-emerald-700 text-lg italic">
//                 Our mission is to bridge the gap between industry challenges and
//                 technology by delivering AI-powered IT solutions that simplify
//                 complex operations, enhance productivity, and create long-term
//                 value for our clients. Guided by innovation, integrity, and
//                 customer-centricity, we strive to transform logistics and allied
//                 industries into smarter, more connected ecosystems.
//               </p>
//             </div>
//           </div>

//           {/* Company Image with 3D + Shadow Effect */}
//           <motion.div
//             className="relative group"
//             initial={{ opacity: 0, y: 50 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8, ease: "easeOut" }}
//             whileHover={{ scale: 1.05, rotateY: 5, rotateX: 5 }}
//           >
//             {/* Subtle background shadow layer */}
//             <div className="absolute inset-0 rounded-2xl bg-emerald-200/40 blur-xl group-hover:blur-2xl transition-all duration-500"></div>

//             {/* Main Image */}
//             <img
//               src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
//               alt="Our Company Team"
//               className="relative rounded-2xl shadow-lg border border-emerald-300 transform group-hover:rotate-1 group-hover:scale-105 transition-all duration-500"
//             />
//           </motion.div>
//         </div>
//         {/* Values Section */}
//         {/* <div className="mb-20">
//           <h2 className="text-3xl font-bold text-center mb-16 text-emerald-600">
//             Our Values
//           </h2>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             <motion.div
//               className="bg-gradient-to-b from-white to-blue-50 p-8 rounded-xl border border-gray-200 group text-center shadow-sm hover:shadow-md transition-shadow"
//               whileHover={{ y: -10, scale: 1.03, borderColor: "#059669" }}
//               transition={{ duration: 0.4 }}
//             >
//               <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-emerald-100 text-2xl text-emerald-600 mb-6">
//                 💡
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-4">
//                 Innovation
//               </h3>
//               <p className="text-gray-600">
//                 We constantly push boundaries to develop cutting-edge Solutions
//                 that transform the shipping and logistics landscape.
//               </p>
//             </motion.div>

//             <motion.div
//               className="bg-gradient-to-b from-white to-blue-50 p-8 rounded-xl border border-gray-200 group text-center shadow-sm hover:shadow-md transition-shadow"
//               whileHover={{ y: -10, scale: 1.03, borderColor: "#059669" }}
//               transition={{ duration: 0.4 }}
//             >
//               <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-emerald-100 text-2xl text-emerald-600 mb-6">
//                 🤝
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-4">
//                 Partnership
//               </h3>
//               <p className="text-gray-600">
//                 We build long-term relationships with our clients, working
//                 collaboratively to achieve their business objectives.
//               </p>
//             </motion.div>

//             <motion.div
//               className="bg-gradient-to-b from-white to-blue-50 p-8 rounded-xl border border-gray-200 group text-center shadow-sm hover:shadow-md transition-shadow"
//               whileHover={{ y: -10, scale: 1.03, borderColor: "#059669" }}
//               transition={{ duration: 0.4 }}
//             >
//               <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-emerald-100 text-2xl text-emerald-600 mb-6">
//                 ⚡
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-4">
//                 Excellence
//               </h3>
//               <p className="text-gray-600">
//                 We are committed to delivering exceptional quality in every
//                 solution we create and every interaction we have.
//               </p>
//             </motion.div>
//           </div>
//         </div> */}
//       </div>
//     </div>
//   );
// };

// export default AboutUs;

import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async"; // ✅ SEO

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-blue-50 to-emerald-50 text-gray-800 py-16 md:py-24">
      {/* ✅ SEO Helmet */}
      <Helmet>
        <title>About Us | Quadrangle Solutions</title>
        <meta
          name="description"
          content="Learn about Quadrangle Solutions - pioneers in AI-powered logistics and shipping software with 15+ years of innovation, integrity, and excellence."
        />
        <meta
          name="keywords"
          content="Quadrangle Solutions, About Quadrangle, Logistics Software Company, AI Shipping Software, Freight Forwarding, Operations Automation"
        />
        <meta property="og:title" content="About Quadrangle Solutions" />
        <meta
          property="og:description"
          content="Quadrangle Solutions has been transforming logistics with AI-driven software solutions since 2010."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://quadranglesolutions.com/about"
        />
        <meta
          property="og:image"
          content="https://quadranglesolutions.com/about-og-image.jpg"
        />
        <link rel="canonical" href="https://quadranglesolutions.com/about" />
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            About <span className="text-emerald-600">Quadrangle Solutions</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto">
            Pioneering software innovation in the shipping and logistics
            industry for over 15 years
          </p>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h2 className="text-3xl font-bold mb-6 text-emerald-600">
              Our Story
            </h2>
            <p className="text-gray-700 text-lg mb-6 leading-relaxed">
              Our story began in 2010, when Quadrangle Solutions was founded in
              India with a simple yet ambitious vision — to make technology
              solve real industry challenges. With modest beginnings, we
              identified a critical gap in the shipping and logistics sector:
              the absence of specialized software that could truly simplify
              complex operations. This realization sparked our journey,
              inspiring us to build AI-driven solutions that not only addressed
              these challenges but also empowered businesses to move faster,
              work smarter, and operate more efficiently.
            </p>
            <div className="bg-gradient-to-r from-emerald-100 to-blue-100 p-6 rounded-xl border border-emerald-300 shadow-sm">
              <p className="text-emerald-700 text-lg italic">
                Our mission is to bridge the gap between industry challenges and
                technology by delivering AI-powered IT solutions that simplify
                complex operations, enhance productivity, and create long-term
                value for our clients. Guided by innovation, integrity, and
                customer-centricity, we strive to transform logistics and allied
                industries into smarter, more connected ecosystems.
              </p>
            </div>
          </div>

          {/* Company Image with 3D + Shadow Effect */}
          <motion.div
            className="relative group"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            whileHover={{ scale: 1.05, rotateY: 5, rotateX: 5 }}
          >
            {/* Subtle background shadow layer */}
            <div className="absolute inset-0 rounded-2xl bg-emerald-200/40 blur-xl group-hover:blur-2xl transition-all duration-500"></div>

            {/* Main Image */}
            <img
              src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
              alt="Quadrangle Solutions Team"
              className="relative rounded-2xl shadow-lg border border-emerald-300 transform group-hover:rotate-1 group-hover:scale-105 transition-all duration-500"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
